"use strict";

var _bus = _interopRequireDefault(require("./bus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClientTable = require('./v-client-table');

var ServerTable = require('./v-server-table');

module.exports = {
  ClientTable: ClientTable,
  ServerTable: ServerTable,
  Event: _bus["default"]
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/index.js
// module id = 1581
// module chunks = 64